import { ProgramModule_mkProgram, ProgramModule_run } from "./fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Program_withReactSynchronous } from "./fable_modules/Fable.Elmish.React.5.0.0/react.fs.js";
import { view, update, init } from "./Root.fs.js";

ProgramModule_run(Program_withReactSynchronous("elmish-app", ProgramModule_mkProgram(init, update, view)));

